import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { ICustomSurveyResponse, IOperationResultNoValue } from '../../surveys/models/Api';

export const useClientCreateCustomSurveyResponseMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: (data?: ICustomSurveyResponse) => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: ({ body, token }: { body: ICustomSurveyResponse; token: string }) => {
			return apiClient.post<ICustomSurveyResponse>(`survey/custom/response/?token=${token}`, body);
		},
		onError,
		onSuccess,
	});
};
